export default "__VITE_ASSET__U6dbl_GK__"